export default sponsorCtrl

/** @ngInject */
function sponsorCtrl($scope, $state, ContractDraft, $stateParams) {
    localStorage.sponsorId = $stateParams.sponsorId

    return $state.go('landing')
}



// WEBPACK FOOTER //
// ./src/states/sponsor/sponsor.js